export default function BrandStory() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-medium tracking-widest uppercase text-primary-600 bg-primary-100/60 px-4 py-1.5 rounded-full mb-4">
            品牌故事
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            深情陪伴，久久如一
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
          <div className="space-y-4">
            <p className="text-foreground-700 leading-relaxed text-sm md:text-base">
              久久伊人诞生于对美好情感的执着追求。十二年前，一群深耕情感研究、心理学和生活方式领域的专业人士聚在一起，他们发现了一个共同的现象：在这个物质日益丰富的时代，人们的情感需求却常常被忽视。
            </p>
            <p className="text-foreground-700 leading-relaxed text-sm md:text-base">
              于是，"久久伊人"应运而生。"久久"寓意长长久久，"伊人"则承载着对每一位追求美好生活的人的敬意。我们希望打造一个温暖的品牌，让每一个来到这里的人都能感受到被理解、被陪伴和被珍视。
            </p>
            <p className="text-foreground-700 leading-relaxed text-sm md:text-base">
              十二年风雨兼程，久久伊人始终坚持"深情陪伴每一天"的品牌理念，从最初的线下情感咨询工作室，逐步发展成为覆盖情感陪伴、品质生活、心灵成长和关系经营等多元领域的综合性情感生活品牌。
            </p>
          </div>
          <div className="relative">
            <img
              src="https://readdy.ai/api/search-image?query=A%20warm%20elegant%20brand%20office%20space%20with%20soft%20natural%20lighting%2C%20team%20members%20having%20a%20gentle%20discussion%20around%20a%20wooden%20table%2C%20creamy%20walls%20with%20delicate%20art%20prints%2C%20indoor%20plants%2C%20cozy%20and%20professional%20atmosphere%2C%20lifestyle%20brand%20photography&width=700&height=500&seq=about-brand-01&orientation=landscape"
              alt="久久伊人品牌团队"
              className="w-full rounded-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
}